module.exports = __webpack_public_path__ + "static/media/stars.b94c0cfc.jpg";